import { mode } from '@chakra-ui/theme-tools';

import { colors } from '../../colors';

// Exports
// 3rd party custom component used in <FilterDatePicker>
export const ChakraReactDatePicker = {
  baseStyle: (props: any) => ({
    bg: mode(colors.white, colors.gray['950'])(props),
  }),
} as const;
